import request from '../helpers/request';

export const changeRequestDescriptionExt = ({
  requestId,
  description,
  showToClient,
}) => {
  return request.put(
    `/Request/set_description_ext/${requestId}`,
    { description, showToClient },
    'Не удалось изменить видимость описания',
    'Error'
  );
};
